import * as mmtz from "moment-timezone";
import { DATETIME_FORMATS } from "../constants/datetime-formats";
import { getCurrentLanguage } from "../helpers/languageHelper";
import { LOCALE_DATE_FORMATS } from "../constants/datetime-formats"
import "moment/locale/ko";
import "moment/locale/vi";

export const convertUTCtoLocalTime = (serverTimeStr) => {
    if (!serverTimeStr) return null;

    const [datePart, fractionPart] = serverTimeStr.split(".");
    let milliseconds = "000";
    if (fractionPart) {
        milliseconds = fractionPart.substring(0, 3).padEnd(3, "0");
    }
    const isoString = `${datePart}.${milliseconds}Z`;

    return mmtz.utc(isoString).local().toDate();
};

export function formatDate(value, format = DATETIME_FORMATS.dddd_DD_MMM_yyyy) {
    return formatWithMoment(value, format);
}

export function formatDateV2(value, dateFormat) {
    return formatWithMoment(value, dateFormat);
}

export function formatDateInEnglish(value, dateFormat) {
    if (!value || !dateFormat) return "";

    const timeZone = mmtz.tz.guess(true);

    return mmtz.utc(value).local().tz(timeZone).locale("en").format(dateFormat);
}

export function buildDateWithTimeUTC(dateValue, timeString) {
    if (!dateValue || !timeString) {
        return null;
    }

    const [hoursStr, minutesStr] = timeString.split(":");
    const hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return null;
    }

    const date = new Date(dateValue);
    date.setUTCHours(hours, minutes, 0, 0);

    return date;
}

function formatWithMoment(
    value,
    format
) {
    const timeZone = mmtz.tz.guess(true);
    const currentLanguage = getCurrentLanguage();
    const localeFormat = convertToLocaleFormat(format);
    mmtz.locale(currentLanguage);
    return mmtz.utc(value).local().tz(timeZone).format(localeFormat);
}

function convertToLocaleFormat(userFormat) {
    if (!userFormat) {
      return userFormat;
    }
  
    const language = getCurrentLanguage();
    const localeFormats = LOCALE_DATE_FORMATS[language];
  
    let result = userFormat; // Default to original format
  
    // Find exact match first
    if (userFormat in localeFormats) {
      result = localeFormats[userFormat];
    } else {
      // Find closest match by checking if the format contains the pattern
      const formatParts = userFormat.split('/');
      if (formatParts.length >= 3) {
        for (const [inputFormat, outputFormat] of Object.entries(localeFormats)) {
          const inputParts = inputFormat.split('/');
          if (inputParts.length >= 3 &&
              userFormat.includes(inputParts[0]) &&
              userFormat.includes(inputParts[1]) &&
              userFormat.includes(inputParts[2])) {
            result = outputFormat;
            break;
          }
        }
      }
    }
    return result;
  }

export function formatDateTime(value) {
    return formatWithMoment(value, DATETIME_FORMATS.DDMMMyyyyHHmmss)
}

export function formatTime(value) {
    const time = formatWithMoment(value, DATETIME_FORMATS.DDMMMyyyyHHmmss);
    return new Date(time).getHours() + ":" + addZero(new Date(time).getMinutes());
}

export function formaTimeWithoutSeconds(value) {
    return formatWithMoment(value, DATETIME_FORMATS.DD_MMM_yyyy_hhmm)
}

function addZero(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}
